import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
	socotraBlue1,
	socotraGray2,
} from '../../../data/globalStylingVariables';

interface Props {
	to: string;
	icon?: JSX.Element | JSX.Element[];
	children: any;
	onKeyDown?: (event: React.KeyboardEvent<HTMLElement>) => void;
	selected?: boolean;
}

const SidePanelLink = (props: Props) => {
	const { icon, to, children, onKeyDown } = props;
	// let displayedLink = null;

	const classNames = ['styled-link'];
	if (props.selected) {
		classNames.push('selected');
	}

	return (
		<StyledLink
			onKeyDown={onKeyDown}
			className={classNames.join(' ')}
			{...props}
			to={to || null}
		>
			{icon}
			{children}
		</StyledLink>
	);
};

export const SidePanelLinkContainer: any = styled.div``;

export const StyledLink = styled(Link)`
	padding: 5px 0;
	min-height: 26px;
	display: flex;
	align-items: center;
	color: ${(props: any) =>
		props.selected ? `${socotraBlue1}` : `${socotraGray2}`};
	font-weight: ${(props: any) => (props.selected ? '700' : 'normal')};
	text-decoration: none;
	font-size: 14px;
	width: 100%;
	outline: none;

	&:focus {
		outline: none;
	}
	&:hover {
		text-decoration: none;
		&.selected {
			color: ${socotraBlue1};
		}
		&:not(.selected) {
			color: ${socotraGray2};
		}
	}
`;

export default SidePanelLink;
